import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPriceSearch = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.4984 10.4978L14.5 14.5M8.48402 4.60418C8.48402 4.60418 8.23131 3.40686 6.46912 3.27665M6.46912 3.27665V2.10428M6.46912 3.27665C6.36281 3.26927 6.25628 3.26518 6.14971 3.2653C5.38386 3.2653 4.38889 3.90276 4.38889 4.79292C4.38889 5.68355 5.10982 6.03244 6.37974 6.24931C7.64966 6.46618 8.54935 6.94393 8.54935 7.9262C8.54935 8.90847 7.49676 9.33722 6.61385 9.33722C6.56558 9.33714 6.51732 9.33624 6.46912 9.33359M4.48371 8.04961C4.48371 8.04961 4.99458 9.25828 6.46912 9.33359M6.46912 9.33359V10.4978M12.214 6.35664C12.214 9.59117 9.59172 12.2133 6.35699 12.2133C3.12227 12.2133 0.5 9.59117 0.5 6.35664C0.5 3.12211 3.12227 0.5 6.35699 0.5C9.59172 0.5 12.214 3.12211 12.214 6.35664Z",
		stroke: "currentColor",
		strokeMiterlimit: 10,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgPriceSearch;
